// extracted by mini-css-extract-plugin
module.exports = {"LoaderConteiner":"LoaderThreeDots_LoaderConteiner__2XoVw","overlayLoader":"LoaderThreeDots_overlayLoader__1cugb"};